import { useState, useEffect } from "react";
import { RedisAdminData, MySQLAdminData, PlannerAdminData } from "../types";

export const useRedisData = () => {
    const [data, setData] = useState<RedisAdminData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetch("/api/admin/redis")
            .then((res) => res.json())
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError("Redis 데이터를 불러오지 못했습니다.");
                setLoading(false);
            });
    }, []);

    return { data, loading, error };
};

export const usePlannerData = () => {
    const [data, setData] = useState<PlannerAdminData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetch("/api/admin/planner")
            .then((res) => res.json())
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError("Planner 데이터를 불러오지 못했습니다.");
                setLoading(false);
            });
    }, []);

    return { data, loading, error };
};

export const usePlannerDataV2 = () => {
    const [data, setData] = useState<PlannerAdminData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetch("/api/admin/planner_v2")
            .then((res) => res.json())
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError("Planner v2 데이터를 불러오지 못했습니다.");
                setLoading(false);
            });
    }, []);

    return { data, loading, error };
};

export const useMySQLData = () => {
    const [data, setData] = useState<MySQLAdminData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetch("/api/admin/mysql")
            .then((res) => res.json())
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError("MySQL 데이터를 불러오지 못했습니다.");
                setLoading(false);
            });
    }, []);

    return { data, loading, error };
};

export const useAdminData = () => {
    const redisResult = useRedisData();
    const mysqlResult = useMySQLData();

    const loading = redisResult.loading || mysqlResult.loading;
    const error = redisResult.error || mysqlResult.error;

    return {
        redisData: redisResult.data,
        mysqlData: mysqlResult.data,
        loading,
        error,
    };
};
